<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="list icon"></i>
      {{ $t("categories") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/teacher_rating.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description">
        <table
          class="ui celled very compact selectable striped table"
          ref="table"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th>{{ $t("category name") }}</th>
              <th>{{ $t("options") }}</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
    </div>
    <div class="actions">
      <div
        class="ui orange left floated icon right labeled button"
        @click="init"
      >
        <i class="refresh icon"></i>
        {{ $t("update") }}
      </div>
      <div
        class="ui green left floated icon right labeled button"
        @click="create"
      >
        <i class="plus icon"></i>
        {{ $t("new") }}
      </div>
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  local_api,
  enterprise_setup,
  init_ajax_data_datables,
  error_toast,
  success_toast,
  register_listener,
} from "@/utils";
// import GenericModal from "@/components/GenericModal";
// import GenericContainer from "@/components/GenericContainer";
// import { v4 } from "uuid";

export default {
  components: {
    // "generic-modal": GenericModal,
    // "generic-container": GenericContainer,
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {};
  },
  methods: {
    show_modal(/* options */) {
      let vm = this;
      // if (options) {
      //   vm.target_template_id = options.target_template_id;
      //   local_api(
      //     vm,
      //     "post",
      //     "/staff_rating/teacher/do-get-evaluation-template",
      //     { i: options.target_template_id },
      //   )
      //     .then((evaluation_template) => {
      //       if (evaluation_template) {
      //         vm.evaluation_template = evaluation_template;
      //       } else {
      //         error_toast(vm.$t("evaluation mode not configured yet"));
      //       }
      //     })
      //     .catch((err) => {
      //       error_toast(err);
      //     });
      // }
      // console.log(options);

      vm.init();

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            // console.log(vm.$refs);
            window.jQuery(vm.$refs.form).form("clear");

            vm.target_user_id = "";
            vm.ratings = [];
            vm.responses = [];
          },
          onShow() {},
        })
        .modal("show");
    },
    init() {
      let vm = this;
      let onSelect = (/* data */) => {
        // vm.select_product(data);
      };

      let columns = [
        {
          data: function (row) {
            // console.log(row);
            return row.name;
          },
        },
        {
          data: function (row) {
            return `<div class="ui orange mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.edit_category', this);"><i class="write icon"></i></div>
                    <div class="ui red mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.delete_category', this);"><i class="trash icon"></i></div>`;
          },
        },
      ];

      vm.table = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["product category url"],
        columns,
        onSelect,
      );

      setTimeout(() => {
        register_listener("modul.edit_category", function (e, element) {
          let uuid = window.jQuery(element).data("uuid");
          let table_data = vm.table.rows().data();
          let final_data = [];
          for (element in table_data) {
            try {
              let isNan = isNaN(element);
              if (!isNan) final_data.push(table_data[element]);
            } catch (error) {
              console.error(error);
            }
          }

          let trgt =
            final_data.find((d) => {
              return d.uuid == uuid;
            }) || {};
          // console.log("final data", final_data);
          vm.$alertify.prompt(
            vm.$t("enter category name"),
            trgt.name,
            function (element, value) {
              local_api(vm, "post", "/product_category/do-simple-update", {
                n: value,
                u: uuid,
              })
                .then(() => {
                  vm.init();
                })
                .catch((err) => {
                  error_toast(err);
                });
            },
          );
        });

        register_listener("modul.delete_category", function (e, element) {
          let uuid = window.jQuery(element).data("uuid");
          vm.$alertify.confirm(
            vm.$t("are you sure to remove category?"),
            function () {
              local_api(vm, "post", "/product_category/do-remove", {
                u: uuid,
              })
                .then(() => {
                  success_toast(vm.$t("category deleted"));
                  vm.init();
                })
                .catch((err) => {
                  error_toast(err);
                });
            },
          );
        });
      }, 500);
    },
    create() {
      let vm = this;
      vm.$alertify.prompt(
        vm.$t("enter category name"),
        "",
        function (element, value) {
          local_api(vm, "post", "/product_category/do-simple-create", {
            n: value,
          })
            .then(() => {
              vm.init();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
  mounted() {
    // let vm = this;
    // local_api(vm, "post", "/product_categories/do-get-all")
    //   .then((conf) => {
    //     if (conf && conf.setup && conf.setup.phone_types)
    //       vm.phone_types = conf.setup.phone_types;
    //     if (conf && conf.setup && conf.setup.templates)
    //       vm.templates = conf.setup.templates;
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
  },
  watch: {},
  updated: function () {
    // this.$nextTick(function () {});
  },
};
</script>
